import React, { useState } from 'react';
import { supabase } from '../supabase';

export function UsernameForm({ user, existingUsername, onSave, onCancel, title = '🩷Flutter Heart' }) {
  const [username, setUsername] = useState(existingUsername || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = username.trim();
    if (!trimmed) { setError('Username cannot be empty.'); return; }
    setLoading(true);
    const { error } = await supabase.from('profiles').upsert({ id: user.id, username: trimmed });
    setLoading(false);
    if (error) {
      setError(error.message.includes('unique') ? 'That username is already taken.' : error.message);
    } else {
      onSave(trimmed);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1 className="auth-title">{title}</h1>
        <form onSubmit={handleSubmit}>
          <h2>{existingUsername ? 'Edit Username' : 'Choose a Username'}</h2>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            maxLength={20}
            autoFocus
            required
          />
          <button type="submit" disabled={loading}>{loading ? 'Saving…' : 'Save'}</button>
          {onCancel && (
            <button type="button" className="link-btn" onClick={onCancel}>Cancel</button>
          )}
        </form>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
}